import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { Switch } from "@/components/ui/switch";
import { WIDGET_REGISTRY } from "./widgetRegistry";
import { motion, AnimatePresence } from "framer-motion";

interface DashboardCustomizerProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	isWidgetEnabled: (id: string) => boolean;
	setWidgetEnabled: (id: string, enabled: boolean) => void;
}

export const DashboardCustomizer = ({
	open,
	onOpenChange,
	isWidgetEnabled,
	setWidgetEnabled,
}: DashboardCustomizerProps) => {
	return (
		<Sheet open={open} onOpenChange={onOpenChange}>
			<SheetContent side="right" className="w-[340px] sm:w-[400px]">
				<SheetHeader>
					<SheetTitle>Customize Dashboard</SheetTitle>
					<SheetDescription>Choose which widgets to display on your dashboard.</SheetDescription>
				</SheetHeader>

				<div className="mt-6 space-y-1">
					<AnimatePresence initial={false}>
						{WIDGET_REGISTRY.map((widget, i) => (
							<motion.div
								key={widget.id}
								layout
								initial={{ opacity: 0, x: 20 }}
								animate={{ opacity: 1, x: 0 }}
								transition={{ delay: i * 0.03, duration: 0.2 }}
								className="flex items-center justify-between rounded-lg p-3 hover:bg-muted/50 transition-colors"
							>
								<div className="flex-1 min-w-0 mr-3">
									<p className="text-sm font-medium">{widget.label}</p>
									<p className="text-xs text-muted-foreground truncate">{widget.description}</p>
								</div>
								<Switch
									checked={isWidgetEnabled(widget.id)}
									onCheckedChange={(checked: boolean) => setWidgetEnabled(widget.id, checked)}
									disabled={widget.alwaysVisible}
								/>
							</motion.div>
						))}
					</AnimatePresence>
				</div>
			</SheetContent>
		</Sheet>
	);
};
